import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

// Per-location liquor management reports: consumption, stock, top sellers.
const base = (restaurantId, locationId) =>
  `${API_URL}/users/restaurant/${restaurantId}/locations/${locationId}/liquor-management`;

const qs = (params = {}) =>
  new URLSearchParams(Object.entries(params).filter(([, v]) => v)).toString();

// Millilitres poured + cost per liquor item. params: { date_from, date_to }
export const getConsumptionReport = async (restaurantId, locationId, params = {}) => {
  const q = qs(params);
  const { data } = await axios.get(`${base(restaurantId, locationId)}/consumption/${q ? `?${q}` : ''}`);
  return data?.data || null;
};

// Current on-hand snapshot with value + low-stock flags.
export const getStockReport = async (restaurantId, locationId) => {
  const { data } = await axios.get(`${base(restaurantId, locationId)}/stock/`);
  return data?.data || null;
};

// Highest-selling liquor items by units & revenue. params: { date_from, date_to, limit }
export const getTopSellingReport = async (restaurantId, locationId, params = {}) => {
  const q = qs(params);
  const { data } = await axios.get(`${base(restaurantId, locationId)}/top-selling/${q ? `?${q}` : ''}`);
  return data?.data || null;
};
